import React, { useState } from 'react';
import toolkitService from '../services/ToolkitService';
import ToolkitBatchPage from './toolkit/ToolkitBatchPage';

// Sync › project › Toolkit › Same-Day Departures — ported from the desktop's OHIP › Same-Day Departures. Lists the
// reservations arriving and departing on one date (PM rooms and house use left out), then moves the chosen ones to
// another rate plan — typically a complimentary one — with their rate amounts zeroed (toolkit property.js
// update-same-day-rateplan). Rows you do not want changed can be filtered out of the grid before processing.

const today = () => new Date().toISOString().slice(0, 10);
const COLUMNS = [
    { key: 'confirmationNo', label: 'Confirmation' },
    { key: 'guestName', label: 'Guest' },
    { key: 'roomId', label: 'Room' },
    { key: 'roomType', label: 'Room type' },
    { key: 'ratePlanCode', label: 'Rate plan' },
    { key: 'reservationStatus', label: 'Status' },
    { key: 'balance', label: 'Balance' },
    { key: 'result', label: 'Result' },
];

function ToolkitSameDayDeparturesPage() {
    const [date, setDate] = useState(today());
    const [newRatePlan, setNewRatePlan] = useState('');
    const fetchRows = async (ctx) => (await toolkitService.property(ctx, 'list-same-day-departures', { date })).data.result.items;
    const request = (row) => ({ area: 'property', op: 'update-same-day-rateplan', args: { resvNameId: row.resvNameId, newRatePlanCode: newRatePlan.trim() } });
    return (
        <ToolkitBatchPage title="Same-Day Departures"
            subtitle="Find the reservations that arrive and depart on the same day and move them to another rate plan."
            queryTitle="Reservations arriving and departing on" fetchRows={fetchRows} canQuery={!!date}
            queryForm={<label><span>Date</span><input type="date" value={date} onChange={(e) => setDate(e.target.value)} /></label>}
            columns={COLUMNS} searchKeys={['confirmationNo', 'guestName', 'ratePlanCode', 'roomId']} exportName="Same_Day_Departures"
            request={request} server={{ screen: 'same-day-departures', title: 'Same-Day Departures', keyOf: (row) => row.resvNameId }}
            canRun={!!newRatePlan.trim()}
            options={(
                <div className="tkb-row">
                    <label><span>New rate plan</span><input type="text" value={newRatePlan} placeholder="e.g. FM0" onChange={(e) => setNewRatePlan(e.target.value.toUpperCase())} style={{ width: 140 }} /></label>
                    <p className="tkb-hint" style={{ margin: 0 }}>The rate amounts are set to zero with it.</p>
                </div>
            )} />
    );
}

export default ToolkitSameDayDeparturesPage;
